class UrlHelper {

	/**
	 * @param uri
	 */
	static getBaseUriAsDesktopSite(uri) {
		return uri.replace('//m.new.', '//www.').replace('//m.', '//www.');
	}

	/**
	 * @param {String} queryString
	 * @return {Object}
	 */
	static getParams(queryString = '') {
		if (queryString.length === 0) {
			return {};
		}

		const params = {};

		for (const pair of queryString
			.substring(queryString.indexOf('?') + 1, queryString.length)
			.split('&')
			.map(pair => pair.split('='))) {
				params[decodeURIComponent(pair[0])] = pair.length === 2
					? decodeURIComponent(pair[1])
					: null;
			}

		return params;
	}

	/**
	 * @param {String} url
	 * @param {String} fileName
	 */
	static forceDownload(url, fileName) {
		const xhr = new XMLHttpRequest();
		xhr.open('GET', url, true);
		xhr.responseType = 'blob';
		xhr.onload = function() {
			const urlCreator = window.URL || window.webkitURL;
			const imageUrl = urlCreator.createObjectURL(this.response);
			const tag = document.createElement('a');
			tag.href = imageUrl;
			tag.download = fileName;
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();
	}
}

export default UrlHelper;
